<template>
  <div>
    <v-layout row justify-center>
      <v-flex xs12 sm6 md4 lg4>
        <v-card v-if=this.items.length>
          <v-toolbar :color="this.getTheme.color" dark>
            <v-toolbar-side-icon></v-toolbar-side-icon>
            <v-toolbar-title>Meus agendamentos</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn icon>
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>done_all</v-icon>
            </v-btn> -->
          </v-toolbar>
          <v-list two-line>
            <template v-for="item in items">
              <v-subheader v-bind:key="item.header" v-if="item.header" v-text="item.header"></v-subheader>
              <v-divider v-bind:key="item.id" v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
              <v-list-tile avatar v-else v-bind:key="item.title">
                <v-list-tile-avatar>
                  <!-- <img v-bind:src="item.avatar"> -->
                  <v-icon>event</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.doctor"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.date"></v-list-tile-sub-title>
                  <v-list-tile-sub-title v-html="item.hour"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple @click.stop="dialogCancel = true" @click.prevent="data(item)">
                    <v-icon color="grey lighten-1">block</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
        <div v-else>
          <p>Você não possui agendamentos!</p>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialogCancel" max-width="500px">
      <v-card>
        <v-card-title>
          Cancelamento de consulta
        </v-card-title>
        <v-card-text>
          <div class="display-1">Deseja Cancelar sua consulta</div>
          <!-- <v-btn color="primary" dark @click.prevent="cancelAppointment()">Cancelar a consulta</v-btn>
          <v-btn color="primary" dark @click.prevent="cancelAppointment()">Fechar</v-btn> -->
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" dark @click.prevent="cancelAppointment()">Cancelar a consulta</v-btn>
          <v-btn color="primary" flat @click.stop="dialogCancel=false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import moment from 'moment'
  // import { url } from '../../../config/api.link.connection'

  export default {
    mounted () {
      this.loadingData()
    },
    methods: {
      data (item) {
        this.item = item
      },
      cancelAppointment () {
        console.log(this.item)
        const item = this.item
        this.$http.post(process.env.URL + '/schedule-online/schedule-sync/cancel-appointment', {
          item
        }, {
          params: {
            customer: this.customer,
            username: this.auth.user.username
          }
        })
          .then((response) => {
            this.dialogCancel = false
            this.loadingData()
            console.log(response)
          }).catch((err) => {
            console.log(err)
          })
      },
      loadingData () {
        this.$http.get(process.env.URL + '/schedule-online/schedule-sync/scheduled-appointment', {
          params: {
            customer: this.customer,
            idUser: this.auth.user.id
          }
        }).then((result) => {
          this.items = result.data.results.map((item) => {
            item.hour = item.hour.substr(0, 5)
            return item
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('app', ['getTheme'])
    },
    data () {
      return {
        dialogCancel: false,
        items: [],
        item: null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/history-schedule-online/index.vue